import { render, staticRenderFns } from "./ReturnBill.vue?vue&type=template&id=a37df994&scoped=true"
import script from "./ReturnBill.vue?vue&type=script&lang=js"
export * from "./ReturnBill.vue?vue&type=script&lang=js"
import style0 from "./ReturnBill.vue?vue&type=style&index=0&id=a37df994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37df994",
  null
  
)

export default component.exports